import { put, call, takeLatest } from "redux-saga/effects";
import { sensorLiveDataConstants } from "../../constants/client";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { sensorLiveData, alertActions } from "../../actions";

function* liveData(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.sensorsUrl.liveData,
      action.payload
    );

    if (data.status === true) {
      yield put(
        sensorLiveData.liveDataSuccess({
          data: data.data,
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
  }
}

export function* sensorLiveDataSaga() {
  yield takeLatest(sensorLiveDataConstants.LIVE_DATA_REQUEST, liveData);
}
